import { canParseImage, parseImage, loadImage, parseToImageBitmap, loadToHTMLImage } from './lib/parse-image';
var EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'ico', 'svg'];
export default {
  name: 'Images',
  extensions: EXTENSIONS,
  parse: canParseImage && parseImage,
  loadAndParse: !canParseImage && loadImage
};
export var ImageBitmapLoader = {
  extensions: EXTENSIONS,
  parse: parseToImageBitmap
};
export var HTMLImageLoader = {
  extensions: EXTENSIONS,
  loadAndParse: loadToHTMLImage
};
//# sourceMappingURL=image-loader.js.map